module.exports = __webpack_public_path__ + "static/media/phone.e6a6bd6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/phone.svg
// module id = 16
// module chunks = 0